/* (c) Copyright Frontify Ltd., all rights reserved. */

export enum MenuItemStyle {
    Primary = 'Primary',
    Danger = 'Danger',
    Warning = 'Warning',
}

export enum SelectionIndicatorIcon {
    Check = 'Check',
    CaretRight = 'CaretRight',
    None = 'None',
}

export enum MenuItemContentSize {
    XSmall = 'XSmall',
    Small = 'Small',
    Large = 'Large',
}

export enum MenuItemContentStyle {
    Primary = 'Primary',
    Danger = 'Danger',
}
